<template>
  <div class="cursor-pointer border-b border-gray1 px-1 py-2" @click="onOpenDetail">
    <div class="flex items-center justify-between">
      <h3 class="text-xl font-medium leading-7 tracking-[0.5px] text-[#1A150E] md:text-gray9">{{ heading }}</h3>
      <button aria-label="Show details" class="drawer-tab-list-item-arrow flex-shrink-0 md:text-gray9" type="button">
        <span class="material-symbols-sharp">chevron_right</span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  heading: string;
  onOpenDetail: () => void;
}
defineProps<Props>();
</script>

<style lang="scss">
.drawer-tab-list-item-arrow {
  color: var(--foreground-fg-primary, var(--Foreground-emphasis, #1a150e));
  font-size: var(--font-size-IconFont, 24px);
  font-style: normal;
  font-weight: 100;
  line-height: var(--line-height-IconFont, 24px);
}
</style>
